import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import {software_update} from '../../assets/conf_urls.json'
import { availablePackage } from '../models/availablePackage';
@Injectable()
export class FileUploadService{

  constructor(private http:HttpClient) {}

  getAll():Observable<{data:availablePackage[]}>{
    return this.http.post<{data:availablePackage[]}>(software_update.services,{
          "event": "queryall"
      });
  }
}
